import { SxProps, Theme } from "@mui/material";

export const modalStyles: Record<string, SxProps<Theme>> = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  previewBox: {
    flexGrow: 1,
    border: '1px solid var(--table-header-bg)',
    borderRadius: 1,
    p: 2,
  },
  loadingBox: {
    display: 'flex',
    justifyContent: 'center',
    py: 4,
  },
  errorBox: {
    color: 'error.main',
    textAlign: 'center',
    py: 4,
  },
  dialogTitle: {
    borderBottom: '1px solid var(--table-header-bg)',
  },
};